import {Component, OnInit} from '@angular/core';

@Component({
  selector: 'app-processed-claims-prov',
  templateUrl: './processed-claims-prov.component.html',
  styleUrls: ['./processed-claims-prov.component.scss']
})
export class ProcessedClaimsProvComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}



// WEBPACK FOOTER //
// ./src/app/pages/billing-provider/processed-claims-prov/processed-claims-prov.component.ts